import React from "react";
import PropTypes from "prop-types";
import StyledFilterTypeCheckbox from "./FilterTypeCheckbox.styled";
import SVGIcon from "../utility/SVGIcon";

const FilterTypeCheckbox = React.memo(props => {
  const { types, name, checkFilter, checked, disabled } = props;
  return (
    <StyledFilterTypeCheckbox className={`filter-product-type__checkbox ${checked && "is-checked"}`}>
      <input disabled={disabled} checked={checked} onChange={() => checkFilter(types.uri_param, name, types.name)} aria-label={name} type="checkbox" />
      <span className="filter-product-type__checkbox__custom">
        {checked ? 
        <>
          <SVGIcon name="filter-check-arrow" className="filter-check-arrow"/>
          <SVGIcon name="filter-check-square" className="filter-check-square"/>
        </>
        : <SVGIcon name="filter-check-square" className="filter-check-square__not-checked"/>}
      </span>
      <p className="t-body-small filter-product-type__checkbox__copy">{types.name}</p>
    </StyledFilterTypeCheckbox>
  );
});

FilterTypeCheckbox.propTypes = {
  types: PropTypes.object.isRequired,
  checkFilter: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FilterTypeCheckbox;